import type { CkSetting } from '~/types/common/cookie'
import { useStorage } from '@vueuse/core'

/** 本地储存键名 */
const configStorageKey = {
  FINGERPRINT: 'fingerprint',
  LANGUAGE: 'language',
  HEADER_FINGERPRINT: 'X-Fingerprint',
  CK_SETTING: 'setting-cookie',
} as const

interface ConfigUI {
  homeVideo: boolean
  navAutoHide: boolean
}

export const useAppStorage = () => {
  /** cookie合规设置 */
  const storageCkSetting = useStorage<CkSetting>(configStorageKey.CK_SETTING, {
    init: false,
    basic: false,
    analytics: false,
    preference: false,
  })

  /** 客户端指纹 */
  const storageFP = useStorage<string>(configStorageKey.FINGERPRINT, '')

  const storageConfigUI = useStorage<ConfigUI>('config-ui', {
    homeVideo: false,
    navAutoHide: true,
  })

  return {
    storageCkSetting,
    storageFP,
    storageConfigUI,
  }
}
